import { useUser } from "@/redux/user";
import { signInStatus } from "@/redux/signIn";
import React, { useState } from "react";
import { validateEmail } from "../../util/validate";
import useTranslation from "next-translate/useTranslation";
import Input from "../../components/ui/input-form";
import styles from "./styles/Settings.module.css";
import { FaCheck } from "react-icons/fa";
import { setLoadingBar } from "../../redux/siteData";
import { api } from "../../services/api";
import { errorCodes } from "@chesshotel/constants";
import { Button } from "@/components/ui/button";

export default function Email() {
  const { t } = useTranslation("common");
  const { t: settingsT } = useTranslation("auth");

  const { hasRecoveryCode } = useUser();
  const [currentPasswordError, setCurrentPasswordError] = useState(null);
  const [currentPassword, setCurrentPassword] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(null);
  const [emailUpdated, setEmailUpdated] = useState(null);

  async function updateEmail() {
    setCurrentPasswordError(null);
    const error = await validateEmail(email);
    setEmailError(error);
    if (!error) {
      setLoadingBar(true);
      api
        .post("/users/email", { email, currentPassword })
        .then(() => {
          setEmailUpdated(true);
          setCurrentPassword("");
          signInStatus();
        })
        .catch((err) => {
          if (hasRecoveryCode && err?.response?.status === 403)
            setCurrentPasswordError("ERROR_CURRENT_PASSWORD");
          else
            setEmailError(
              err?.response?.status === 429
                ? "ERROR_AUTH_RATE_LIMIT"
                : errorCodes.ERROR_EMAIL_NOT_AVAILABLE
            );
        })
        .then(() => {
          setLoadingBar(false);
        });
    }
  }

  return (
    <div className={styles.body}>
      <div className={styles.title}>
        {settingsT("Update email")}{" "}
        {emailUpdated && (
          <div className={styles.doneCheck}>
            <FaCheck />
          </div>
        )}
      </div>
      <div className={styles.form}>
        {hasRecoveryCode && (
          <p className="mb-4 text-sm">
            {settingsT("optionalEmailExplanation")}
          </p>
        )}
        <Input
          className={styles.margin}
          id="settings-email"
          autoComplete="email"
          onChange={(e) => setEmail(e.target.value)}
          label={t("Email")}
          type="text"
          value={email}
          errorCode={emailError}
        />
        {hasRecoveryCode && (
          <Input
            id="email-current-password"
            autoComplete="current-password"
            className={styles.margin}
            value={currentPassword}
            errorCode={currentPasswordError}
            onChange={(e) => setCurrentPassword(e.target.value)}
            label={settingsT("currentAccountPassword")}
            type="password"
          />
        )}
        {emailUpdated && hasRecoveryCode && (
          <p role="status" className="mb-3 text-sm">
            {settingsT("Please check your email to confirm your account")}
          </p>
        )}
        <Button variant="default" size="wide" onClick={() => updateEmail()}>
          {t("Save")}
        </Button>
      </div>
    </div>
  );
}
